@import (reference) '../../../../../constants/spacing.module.less';

.header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: @space-16 @space-24;
  border-bottom: 1px solid var(--grey-200);
}

.title {
  font-weight: 600;
  color: var(--grey-900);
}

.close-wrapper {
  display: flex;
  align-items: center;
}
